import { render, staticRenderFns } from "./VChartHeaderSimple.vue?vue&type=template&id=0953bb52&scoped=true&"
import script from "./VChartHeaderSimple.vue?vue&type=script&lang=ts&"
export * from "./VChartHeaderSimple.vue?vue&type=script&lang=ts&"
import style0 from "./VChartHeaderSimple.vue?vue&type=style&index=0&id=0953bb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953bb52",
  null
  
)

export default component.exports